<app-data-table [title]="type + 's'"
                [columns]="columns"
                [fetchDataFn]="loadData"
                [exportDataFn]="exportData"
                [reloadEmitter]="reloadTable$"
                [enableGlobalSearch]="true"
                [globalFilterFields]="['title']"
                globalSearchPlaceholder="Search by document title"
                defaultSortField="date"
                defaultSortOrder="desc"
                [exportable]="authService.hasPermission('districts.district_documents.export')">
</app-data-table>
